import { cloneDeep, isEmpty, map, set } from "lodash";
import { useEffect, useRef } from "react";
import { ChatAssistantNode } from "./ChatAssistantNode";
import styles from "./ChatContent.module.scss";
import { ChatType } from "./ChatInterfaceBloc";
import { ChatTips } from "./ChatTips";
import { ChatUserNode } from "./ChatUserNode";

export interface Props {
  onLinkClicked: () => void;
  chatList: Array<ChatType>;
  isShare: boolean;
  isStreamStopped: boolean;
  textAreaValueChatList: Array<ChatType>;
  AssistantDefaultList: Array<string>;
  onRegenerateClicked: () => void;
  onRefreshHeight: () => void;
  onStreamingContentStopped: (chatList?: ChatType[]) => void;
}

export function ChatContent(props: Props) {
  const chatListUpdateCountRef = useRef(0);
  const messageListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollToBottom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.chatList]);

  function scrollToBottom() {
    props.onRefreshHeight();
  }

  useEffect(() => {
    if (props.textAreaValueChatList?.length) {
      chatListUpdateCountRef.current = chatListUpdateCountRef.current + 1;
    }
  }, [props.textAreaValueChatList]);

  return (
    <div className={styles.messageList} ref={messageListRef}>
      <ChatTips onLinkClicked={() => props.onLinkClicked()} />
      {map(props.AssistantDefaultList, (item, index) => {
        return (
          <div key={item + index} className={styles.messageItem}>
            <ChatAssistantNode
              showMask={true}
              isLast={false}
              isError={false}
              disabledStream
              message={item}
              onRegenerateClicked={() => props.onRegenerateClicked()}
            />
          </div>
        );
      })}
      {map(props.chatList, (item, index, array) => {
        let nextItem: ChatType | undefined = undefined;
        if (index < props.chatList.length) {
          nextItem = props.chatList[index + 1];
        }

        if (item.type === "Assistant") {
          const isLast = array.length - 1 === index;
          // use streaming only the latest chat item and exclude first props loading
          const disabledStream = !isLast && !props.isShare && chatListUpdateCountRef.current > 1;
          return (
            <div key={`${item.value}${index}`} className={styles.messageItem}>
              <ChatAssistantNode
                showMask={nextItem === undefined || nextItem.type === "User"}
                isLast={isLast}
                disabledStream={disabledStream}
                isError={false}
                message={item.value}
                isStreamStopped={props.isStreamStopped}
                onRegenerateClicked={() => {
                  props.onRegenerateClicked();
                }}
                onStreamingContentChanged={() => scrollToBottom()}
                onStreamingContentStopped={value => {
                  if (!isEmpty(value)) {
                    const chatList = cloneDeep(props.isShare ? props.chatList : props.textAreaValueChatList);
                    set(chatList, index, value);
                    props.onStreamingContentStopped(chatList);
                  } else {
                    props.onStreamingContentStopped();
                  }
                  scrollToBottom();
                }}
              />
            </div>
          );
        }

        if (item.type === "Error") {
          return (
            <div key={`${item.value}${index}`} className={styles.messageItem}>
              <ChatAssistantNode
                showMask={false} //{nextItem === undefined || nextItem.type === "User"}
                disabledStream
                isError={true}
                isLast={array.length - 1 === index}
                message={item.value}
                onRegenerateClicked={() => props.onRegenerateClicked()}
              />
            </div>
          );
        }

        if (item.type === "User") {
          return (
            <div key={`${item.value}${index}`} className={styles.messageItem}>
              <ChatUserNode
                showMask={nextItem === undefined || nextItem.type === "Error" || nextItem.type === "Assistant"}
                message={item.value}
              />
            </div>
          );
        }

        return <div key={item.value}></div>;
      })}
    </div>
  );
}
